/**
 * Cultural Aspect Item Component
 * Displays individual cultural aspect with heading and description
 * Follows Single Responsibility Principle - only responsible for rendering a single aspect item
 * Uses shared BulletListItem component
 */

import React from 'react';
import { BulletListItem } from '../shared/BulletListItem';
import { CulturalAspect } from './types';

export interface CulturalAspectItemProps {
  /**
   * Cultural aspect data
   */
  aspect: CulturalAspect;
}

/**
 * Cultural Aspect Item Component
 * Renders a single cultural aspect using the shared bullet list item component
 * Matches Figma design: bullet point with bold heading followed by colon and description
 */
export const CulturalAspectItem: React.FC<CulturalAspectItemProps> = ({
  aspect,
}) => {
  return (
    <BulletListItem
      item={{
        id: aspect.id,
        heading: aspect.heading,
        description: aspect.description,
      }}
    />
  );
};
